// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"ce3f7b70","345":"8623757e","385":"6dba7398","409":"787d3cc2","548":"a3105c75","618":"01e134e8","738":"bda229c7","774":"32fb70dc"}[chunkId] + ".chunk.js";
};